import { render, staticRenderFns } from "./nshop-order-view-table.vue?vue&type=template&id=f333f344&scoped=true&"
import script from "./nshop-order-view-table.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-table.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view-table.vue?vue&type=style&index=0&id=f333f344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f333f344",
  null
  
)

export default component.exports